import { CalendarOptions } from '@fullcalendar/core';
import { DetailModalActions, Legends } from './interfaces';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import dayGridPlugin from '@fullcalendar/daygrid';

export function getCalendarOptions(resourcesLabel: string, schedulerLicenseKey: string): CalendarOptions {
  return {
    plugins: [
      dayGridPlugin,
      timeGridPlugin,
      interactionPlugin,
      resourceTimelinePlugin,
      momentTimezonePlugin,
    ],
    schedulerLicenseKey,
    headerToolbar: false,
    initialView: 'resourceTimelineDay',
    views: {
      resourceTimelineDay: {
        slotDuration: '00:15',
      },
    },
    resourceAreaHeaderContent: resourcesLabel,
    resourceAreaWidth: '20%',
    nowIndicator: true,
    resourceGroupField: 'belongTo',
    droppable: true,
    weekends: true,
    stickyFooterScrollbar: true,
    resourcesInitiallyExpanded: true,
    selectable: true,
    selectMirror: true,
    height:'auto',
  }
}

export const legends: Legends = {
  checkIn: true,
  served: true,
  notServed: true,
  notChecked: true,
};

export const statusStyles = {
  checkIn: {
    backgroundColor: '#ffb309',
    textColor: '#000',
  },
  served: {
    backgroundColor: '#2daf17',
    textColor: '#000',
  },
  notServed: {
    backgroundColor: '#4eceff',
    textColor: '#000',
  },
  notChecked: {
    backgroundColor: '#ef5043',
    textColor: '#000',
  },
};

export const sort = ['order', 'name', 'category'];

export const defaultDetailModalActions: DetailModalActions = {
  edit: true,
  cancel: true,
  chat: true,
};
